import { ImgHTMLAttributes } from 'react';

export interface CustomSvgIconProps {
  width?: ImgHTMLAttributes<HTMLImageElement>['width'];
  height?: ImgHTMLAttributes<HTMLImageElement>['height'];
  variant?: IconType;
}

export enum IconType {
  Default = 'default', // #000000
  Pure = 'pure', // #ffffff
  Disabled = 'disabled', // #20202061
  Light = 'light', // #3BB8F0
  Gray = 'gray', // rgba(32, 32, 32, 0.68) | #202020AD
  Dropdown = 'dropdown', // #868686
  Dark = 'dark', // #002C77
  Blue = 'blue', // #009DE0
  Error = 'error', // #C53532
}

/**
 * To change the color of .svg we must use the css prop 'filter':
 * https://developer.mozilla.org/en-US/docs/Web/CSS/filter#formal_definition
 * Filters can be calculated with tools like this:
 * https://isotropic.co/tool/hex-color-to-css-filter/
 *
 * Note: the color of the .svg file must be black so that the tools
 *  calculate the filters correctly.
 *
 * Note: there are RGBA colors that have another property called 'alpha'
 * which stands for the opacity for a color (ref: https://www.w3schools.com/css/css_colors_rgb.asp)
 * To use the css prop 'filter' for it, you need to add opacity to the filter.
 * If you have the color in HEX (e.g. #20202061), you can use tool like
 * https://rgbacolorpicker.com/hex-to-rgba to convert it to rgba
 * and then take the opacity from the 'a' value.
 * For example, the color #20202061 in HEX is rgba(32, 32, 32, 0.38) in RGBA so you need to add
 * opacity(0.38) to the filter.
 */
export const SvgFilterByIconType: Partial<{ [key in IconType]: string }> = {
  [IconType.Pure]:
    'invert(100%) sepia(100%) saturate(0%) hue-rotate(311deg) brightness(108%) contrast(102%)',
  [IconType.Disabled]:
    'invert(0%) sepia(1%) saturate(7484%) hue-rotate(320deg) brightness(110%) contrast(75%) opacity(0.38)',
  [IconType.Light]:
    'invert(64%) sepia(50%) saturate(1637%) hue-rotate(167deg) brightness(98%) contrast(92%)',
  [IconType.Gray]:
    'invert(11%) sepia(9%) saturate(8%) hue-rotate(359deg) brightness(94%) contrast(94%) opacity(0.68)',
  [IconType.Dropdown]:
    'invert(56%) sepia(0%) saturate(0%) hue-rotate(241deg) brightness(96%) contrast(83%)',
  [IconType.Dark]:
    'invert(7%) sepia(98%) saturate(5342%) hue-rotate(214deg) brightness(95%) contrast(101%)',
  [IconType.Blue]:
    'invert(73%) sepia(72%) saturate(6408%) hue-rotate(168deg) brightness(94%) contrast(101%)',
  [IconType.Error]:
    'invert(23%) sepia(54%) saturate(2093%) hue-rotate(334deg) brightness(113%) contrast(97%)',
};
